import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=78700b84&scoped=true&lang=html"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78700b84",
  null
  
)

export default component.exports